import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { useWithdrawStore } from '@/store/useWithdrawStore'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import { currencyUtils } from '@/utils'

const { formatDynamicCurrency, cryptoToBig, cryptoToFiat } = currencyUtils

export const WithdrawMaximumButton: React.FC = () => {
  const { t } = useTranslation()

  const selectedCryptoWalletData = useWithdrawStore(
    (state) => state.selectedCryptoWalletData,
  )
  const setIsFiatMode = useWithdrawStore((state) => state.setIsFiatMode)
  const setCryptoAmount = useWithdrawStore((state) => state.setCryptoAmount)
  const setFiatAmount = useWithdrawStore((state) => state.setFiatAmount)
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  if (!selectedCryptoWalletData) {
    return null
  }

  const handlePress = () => {
    // Логика аналогичная React Native версии
    const bigAmount = cryptoToBig({
      amount: selectedCryptoWalletData.amount ?? '0',
    })

    const fiatAmount = cryptoToFiat({
      amountCrypto: Number(selectedCryptoWalletData.amount ?? '0'),
      cryptoPricePerUnit: selectedCryptoWalletData.pricePerUnit ?? 0,
    })

    // Устанавливаем режим крипто (как в RN версии)
    setIsFiatMode(false)

    setCryptoAmount({
      amount: bigAmount,
      code: selectedCryptoWalletData.code ?? 'USDT',
    })

    setFiatAmount({
      amount: fiatAmount,
      code: displayCurrency?.isin || 'USD', // Используем displayCurrency как в RN версии
    })
  }

  // Форматируем сумму для отображения
  const formattedAmount = formatDynamicCurrency({
    amount: selectedCryptoWalletData.amount ?? '0',
    currencyCode: selectedCryptoWalletData.code ?? 'USDT',
  })

  const availableAmount = `Maximum: ${formattedAmount}`

  return (
    <BaseView center>
      <div
        onClick={handlePress}
        style={{ alignSelf: 'center', cursor: 'pointer' }}
        className="transition-opacity duration-200 hover:opacity-80"
      >
        <BaseText
          fontSize={16}
          fontFamily="semibold"
          color="label.clickable"
          textAlign="center"
        >
          {availableAmount}
        </BaseText>
      </div>
    </BaseView>
  )
}
